import { render } from "./ReviewAudit.vue?vue&type=template&id=c81b9e2c&scoped=true"
import script from "./ReviewAudit.vue?vue&type=script&lang=js"
export * from "./ReviewAudit.vue?vue&type=script&lang=js"

import "./ReviewAudit.vue?vue&type=style&index=0&id=c81b9e2c&scoped=true&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\sport.yanhuotiyu.com焱火pc端web网站\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c81b9e2c"]])

export default __exports__